import { memo } from "react";
import { Flex } from "../flex";
import * as css from "./product-tile.module.css";

interface ImageGalleryProps {
  images: { url: string; altText?: string }[];
  currentIndex: number;
  onImageClick: (index: number) => void;
}

export const ImageGallery = memo(function ImageGallery({
  images,
  currentIndex,
  onImageClick,
}: ImageGalleryProps) {
  if (images.length <= 1) {
    return null;
  }

  return (
    <Flex gap="sm" overflowX="auto" px="xl">
      {images.map((img, idx) => (
        <Flex
          borderColor={idx === currentIndex ? "border-alt" : undefined}
          borderStyle={idx === currentIndex ? "solid" : undefined}
          borderWidth="2px"
          className={css.galleryThumbnail}
          cursor="pointer"
          key={img.url}
          onClick={(e) => {
            e.stopPropagation();
            onImageClick(idx);
          }}
          onMouseDown={(e) => e.stopPropagation()}
          overflow="hidden"
          radius="sm"
          shrink={0}
        >
          <img
            alt={img.altText ?? ""}
            className={css.galleryThumbnailImage}
            src={img.url}
          />
        </Flex>
      ))}
    </Flex>
  );
});
